module.exports = __webpack_public_path__ + "static/media/4s.0a625725.png";